export default __webpack_public_path__ + "static/media/icon-safu.131a73fa.svg";